const _excluded = ["strategy", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import AlignContext, { inertAlignContextProps } from "./AlignContext";
import { getStyle } from "./AlignProps";

// Generates styles necessary to align its descendant components based on the
// provided alignment configuration and the reference.
class AlignTarget extends React.Component {
  render() {
    const _this$props = this.props,
          {
      strategy,
      children
    } = _this$props,
          remaining = _objectWithoutProperties(_this$props, _excluded);

    if (strategy === 'skip') {
      return children({}, false);
    }

    return /*#__PURE__*/React.createElement(AlignContext.Consumer, null, context => {
      const style = _objectSpread(_objectSpread({}, remaining.style), getStyle(this.props, context));

      const childProps = Object.keys(style).length ? {
        style
      } : {};
      return /*#__PURE__*/React.createElement(AlignContext.Provider, {
        value: inertAlignContextProps
      }, children(childProps, context !== inertAlignContextProps));
    });
  }

}

AlignTarget.defaultProps = {
  nestable: false,
  typeface: 'base',
  size: 0
};
export default AlignTarget;